/**
 * Replaces `{{userFirstName}}` and `{{agentName}}` in a welcome intro template.
 * Missing values become empty strings.
 *
 * @param {string} template
 * @param {{ userFirstName?: string, agentName?: string }} values
 * @returns {string}
 */
export function applyIntroMessagePlaceholders(template, values) {
  const u = values.userFirstName == null ? '' : String(values.userFirstName);
  const a = values.agentName == null ? '' : String(values.agentName);
  return String(template)
    .replaceAll('{{userFirstName}}', u)
    .replaceAll('{{agentName}}', a);
}
